import { Globe, Share2, Link2, Mail } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer-shell" aria-labelledby="footer-heading">
      <div className="footer-top">
        <div className="footer-brand">
          <p className="footer-brand-name">VanByte Technologies Pvt Ltd</p>
          <p className="footer-brand-copy">Premium cloud engineering, software delivery, and managed operations.</p>
        </div>
        <div className="footer-links-grid">
          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="#services">Services</a></li>
              <li><a href="#cta">Contact</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div>
            <h4>Services</h4>
            <ul>
              <li><a href="/cloud-solutions/cloud-platform">Cloud Platforms</a></li>
              <li><a href="/cloud-solutions/cloud-services">Cloud Services</a></li>
              <li><a href="/cloud-solutions/cost-optimization">Cost Optimization</a></li>
            </ul>
          </div>
          <div>
            <h4>Contact</h4>
            <ul>
              <li><a href="mailto:info@vanbyte.in">info@vanbyte.in</a></li>
              <li>Vadodara, India</li>
              <li>+91 88496 11216</li>
            </ul>
          </div>
          <div>
            <h4>Social</h4>
            <div className="social-icons">
              <a href="https://www.vanbyte.in" target="_blank" rel="noreferrer" aria-label="Official website"><Globe size={18} /></a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Company updates"><Share2 size={18} /></a>
              <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="Professional network"><Link2 size={18} /></a>
              <a href="mailto:info@vanbyte.in" aria-label="Email contact"><Mail size={18} /></a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 VanByte Technologies Pvt Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
}
